export const PURCHASE_DATA = "PURCHASE_DATA";
export const PURCHASE_DATA_SUCCESS = "PURCHASE_DATA_SUCCESS";
export const PURCHASE_DATA_FAILED = "PURCHASE_DATA_FAILED";
export const SHOW_PURCHASE_CONFIRMATION = "SHOW_PURCHASE_CONFIRMATION";
export const SHOW_PURCHASE_CONFIRMATION_SUCCESS =
  "SHOW_PURCHASE_CONFIRMATION_SUCCESS";
export const SHOW_PURCHASE_CONFIRMATION_FAILED =
  "SHOW_PURCHASE_CONFIRMATION_FAILED";
export const CONFIRM_PURCHASE = "CONFIRM_PURCHASE";
export const CONFIRM_PURCHASE_SUCCESS = "CONFIRM_PURCHASE_SUCCESS";
export const CONFIRM_PURCHASE_FAILED = "CONFIRM_PURCHASE_FAILED";
export const SET_SIP_DETAILS = "SET_SIP_DETAILS";
export const SET_NEW_PAN = "SET_NEW_PAN";
export const SIP_SAVE_DATA = "SIP_SAVE_DATA";
export const SIP_SAVE_DATA_SUCCESS = "SIP_SAVE_DATA_SUCCESS";
export const SIP_SAVE_DATA_FAILED = "SIP_SAVE_DATA_FAILED";
export const SET_SWITCH_DETAILS = "SET_SWITCH_DETAILS";
export const SWITCH_SAVE_DATA = "SWITCH_SAVE_DATA";
export const SWITCH_SAVE_DATA_SUCCESS = "SWITCH_SAVE_DATA_SUCCESS";
export const SWITCH_SAVE_DATA_FAILED = "SWITCH_SAVE_DATA_FAILED";
export const SET_STP_DETAILS = "SET_STP_DETAILS";
export const STP_SAVE_DATA = "STP_SAVE_DATA";
export const STP_SAVE_DATA_SUCCESS = "STP_SAVE_DATA_SUCCESS";
export const STP_SAVE_DATA_FAILED = "STP_SAVE_DATA_FAILED";
export const GET_EARNINGS = "GET_EARNINGS";
export const GET_EARNINGS_SUCCESS = "GET_EARNINGS_SUCCESS";
export const GET_EARNINGS_FAILED = "GET_EARNINGS_FAILED";

export const SAVE_TRANSACTION_DETAILS = "SAVE_TRANSACTION_DETAILS";